<template>
  <display-section gap="l">
    <render />
  </display-section>
</template>
<script setup lang="ts">
interface Props {
  fromProfiling?: boolean;
}

const props = defineProps({
  fromProfiling: { type: Boolean, default: false }
});

const {
  libraryViewRouter: { view },
} = inject(INJECT_LIBRARY_PAGE_OR_FORM);

const render = () => {
  return h(view.value, props);
};
</script>
